import { useState, useEffect } from 'react';
import checkOnlineStatus from 'utils/CheckOnlineStatus';

export function useCheckConnection() {
  const [onlineStatus, setOnlineStatus] = useState<boolean>(true);

  const MINUTE_MS = 60000; // 1 min

  useEffect(() => {
    const interval = setInterval(async () => {
      setOnlineStatus(await checkOnlineStatus());

    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);

  return onlineStatus;
}